import * as actionTypes from './actionTypes'
import tasksApi from './../../api/tasks';
import { profileUpdateStages } from '../profile/actions';

const myTaskRequest = () => ({
  type: actionTypes.MY_TASK_REQUEST
});

const myTaskReceive = data => ({
  type: actionTypes.MY_TASK_RECEIVE,
  data,
});

const myTaskError = error => ({
  type: actionTypes.MY_TASK_ERROR,
  error,
});

export const myTaskInvalidate = () => ({
  type: actionTypes.MY_TASK_INVALIDATE,
});

const myTaskFetch = () => dispatch => {
  dispatch(myTaskRequest());
  return tasksApi.getMyTask().then(data => dispatch(myTaskReceive(data))).catch(error => {
    dispatch(myTaskError(error));
    throw error;
  });
};

const myTaskShouldFetch = state => {
  const myTaskState = state;
  if (myTaskState.isFetching) {
    return true;
  }
  if (!myTaskState.data) {
    return false;
  }
  return myTaskState.didInvalidate;
};

export const myTaskFetchIfNeeded = () => (dispatch, getState) => {
  if (!myTaskShouldFetch(getState().myTask)) {
    return Promise.resolve();
  }
  return dispatch(myTaskFetch());
};

const myTaskUpdateRequest = () => ({
  type: actionTypes.MY_TASK_UPDATE_REQUEST
});

const myTaskUpdateReceive = data => ({
  type: actionTypes.MY_TASK_UPDATE_RECEIVE,
  data,
});

const myTaskUpdateError = error => ({
  type: actionTypes.MY_TASK_UPDATE_ERROR,
  error,
});

export const myTaskAcceptFetch = id => dispatch => {
  dispatch(myTaskUpdateRequest());
  return tasksApi.acceptTask(id).then(data => dispatch(myTaskUpdateReceive(data))).catch(error => dispatch(myTaskUpdateError(error)));
};

export const myTaskCompleteFetch = id => dispatch => {
  return dispatch(profileUpdateStages({
    essay_id: +id,
  })).then(() => dispatch(myTaskFetch())).catch(error => dispatch(myTaskUpdateError(error)));
};

export const myTaskUploadFetch = fileList => dispatch => {
  if (!fileList.length) {
    return Promise.resolve();
  }
  dispatch(myTaskUpdateRequest());
  return tasksApi.uploadFiles(fileList).then(data => dispatch(myTaskUpdateReceive(data))).catch(error => dispatch(myTaskUpdateError(error)));
};

export const myTaskActionFileFetch = fileList => dispatch => {
  if (!fileList.length) {
    return Promise.resolve();
  }
  dispatch(myTaskUpdateRequest());
  return tasksApi.actionFiles(fileList).then(data => dispatch(myTaskUpdateReceive(data))).catch(error => dispatch(myTaskUpdateError(error)));
};



// WEBPACK FOOTER //
// ./src/store/myTask/actions.js